var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"bgimage",rawName:"v-bgimage",value:(_vm.item.image),expression:"item.image"}],staticClass:"divider-2"},[_c('div',{staticClass:"divider-2-inner inner"},[_c('div',{staticClass:"divider-2-text"},[_vm._v(_vm._s(_vm.item.text))]),_c('div',{staticClass:"divider-2-subtitle"},[_vm._v(_vm._s(_vm.item.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }